/**
 * 쿠폰 발급 경로
 * PhoneGrant: 전화번호 지급 쿠폰 / ShareCode: 공유 코드 쿠폰 / UniqueCode: 개별 코드 쿠폰
 */
export enum CouponIssueRoute {
  PhoneGrant = 'PhoneGrant',
  ShareCode = 'ShareCode',
  UniqueCode = 'UniqueCode',
}

/**
 * 쿠폰 이용 방식
 * Relative: 상대기간형(N일) / Fixed: 기간고정형(시작일~종료일)
 */
export enum CouponApplyType {
  Relative = 'Relative',
  Fixed = 'Fixed',
}

/**
 * 쿠폰을 지금 사용할 수 없는 사유 (usableNow === false 인 경우)
 * NotStarted: 기간고정형 쿠폰의 이용 시작일 전
 * AlreadyUsingPass: 이미 이용 중인 이용권·쿠폰 보유
 */
export enum CouponBlockedReason {
  NotStarted = 'NotStarted',
  AlreadyUsingPass = 'AlreadyUsingPass',
}

/**
 * 쿠폰 코드 등록 실패 사유 (GA 이벤트 파라미터용)
 * format·server 는 프론트가 판별하고, 나머지는 서버가 `extensions.extra.reason` 으로 내려준다.
 */
export enum CouponRegisterFailReason {
  format = 'format',
  invalid = 'invalid',
  server = 'server',
  expired = 'expired',
  limit = 'limit',
  disabled = 'disabled',
  duplicate = 'duplicate',
  cross_duplicate = 'cross_duplicate',
  used_by_other = 'used_by_other',
  unique_per_account = 'unique_per_account',
}

/**
 * 쿠폰 이용 이력 상태 (서버 원본값)
 * Active: 이용 중 / Completed: 기간 종료 / Expired: 만료 / Released: 관리자 회수
 * Suspended: 계정 이용 제한 중 (해제되면 Active 또는 Completed 로 돌아온다)
 * 고객 화면에서는 Completed=이용 완료, Expired·Released=만료, Suspended=이용 중지 로 노출한다.
 */
export enum CouponHistoryStatus {
  Active = 'Active',
  Completed = 'Completed',
  Expired = 'Expired',
  Released = 'Released',
  Suspended = 'Suspended',
}
